import { BareActionContext } from 'vuex-typex'
import { AuthState } from '../state'
import { RootState } from '@/store/'
import authStore from '../auth-store'
import authUtils from './auth-utils'
import { IUser } from '../../../model/user'
import logout from './logout'

export default async function verifyToken(context: BareActionContext<AuthState, RootState>, token: string)
{
    authUtils.authService.logout().then((result: any) => {
        authUtils.authService.verifyToken(token).then((user: IUser | null) => {
            if (!user) {
                authStore.commitSetNotAuthenticated()
            } else {
                authStore.commitSetUser({ user: user })
            }
        }).catch((err) => {
            logout(context)
        })
    })
}
